import React, { useState } from "react";
import "./ChecklistImportPreview.scss";

// Preview responses are local UI state and are never included in the import payload.
export default function ChecklistImportPreview({ draft }) {
  const sections = [
    ...new Set(draft.questions.map((question) => question.section)),
  ];
  const [section, setSection] = useState(sections[0]);
  const [sectionSearch, setSectionSearch] = useState("");
  const [search, setSearch] = useState("");
  const [answers, setAnswers] = useState({});
  const questions = draft.questions.filter(
    (question) => question.section === section
  );

  return (
    <div className="checklist-import__workspace checklist-import-preview">
      <aside>
        <strong className="checklist-import__section-totals">
          {sections.length} sections · {draft.questions.length} questions
        </strong>
        <input
          aria-label="Search preview sections"
          placeholder="Search sections…"
          value={sectionSearch}
          onChange={(event) => setSectionSearch(event.target.value)}
        />
        {sections
          .filter((name) =>
            name.toLowerCase().includes(sectionSearch.toLowerCase())
          )
          .map((name) => (
            <button
              key={name}
              className={section === name ? "selected" : ""}
              onClick={() => {
                setSection(name);
                setSearch("");
              }}
            >
              <strong>{name}</strong>
              <small>
                {
                  draft.questions.filter(
                    (question) => question.section === name
                  ).length
                }{" "}
                questions
              </small>
              <i className="bx bx-chevron-right" />
            </button>
          ))}
      </aside>
      <section className="checklist-import__questions">
        <h2>Preview checklist</h2>
        <p>See how the checklist will appear to reviewers.</p>
        <p className="checklist-import-preview__notice" role="status">
          Preview mode · Responses entered here will not be saved.
        </p>
        <div className="checklist-import__toolbar">
          <div>
            <h2>{section}</h2>
            <small>{questions.length} questions</small>
          </div>
          <input
            aria-label="Search preview questions"
            placeholder="Search questions…"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </div>
        {questions
          .filter((question) =>
            `${question.referenceNo} ${question.question}`
              .toLowerCase()
              .includes(search.toLowerCase())
          )
          .map((question) => (
            <article
              key={question.key}
              className="checklist-import-preview__question"
            >
              <span className="checklist-import-preview__number">
                {question.referenceNo}
              </span>
              <h3>{question.question}</h3>
              <header>
                {question.required && question.answerType !== "None" && (
                  <span className="checklist-import-preview__required">
                    Required
                  </span>
                )}
              </header>
              {question.answerType === "None" ? null : question.answerType === "Yes / No / N/A" ? (
                <fieldset
                  aria-label={`Preview answer for ${question.referenceNo}`}
                >
                  {["Yes", "No", "N/A"].map((answer) => (
                    <label
                      key={answer}
                      className={
                        answers[question.key] === answer
                          ? `is-selected ${answer === "No" ? "is-no" : ""}`
                          : ""
                      }
                    >
                      <input
                        type="radio"
                        name={`preview-${question.key}`}
                        value={answer}
                        checked={answers[question.key] === answer}
                        onChange={() =>
                          setAnswers((current) => ({
                            ...current,
                            [question.key]: answer,
                          }))
                        }
                      />{" "}
                      <span
                        className="checklist-import-preview__radio"
                        aria-hidden="true"
                      />
                      {answer}
                    </label>
                  ))}
                </fieldset>
              ) : question.answerType === "Long text" ? (
                <textarea
                  aria-label={`Preview answer for ${question.referenceNo}`}
                  placeholder="Enter response…"
                />
              ) : (
                <input
                  aria-label={`Preview answer for ${question.referenceNo}`}
                  type={
                    question.answerType === "Number"
                      ? "number"
                      : question.answerType === "Date"
                      ? "date"
                      : "text"
                  }
                />
              )}
              <div className="checklist-import-preview__details">
                {question.supporting && (
                  <p>
                    <strong>Supporting requirements</strong>
                    <br />
                    {question.supporting}
                  </p>
                )}
                {question.explanation && (
                  <p>
                    <strong>Explanation rule</strong>
                    <br />
                    {question.explanation}
                  </p>
                )}
                {question.sourcePage && (
                  <p>Source: PDF page {question.sourcePage}</p>
                )}
              </div>
              {answers[question.key] === "No" && (
                <label className="checklist-import-preview__comments">
                  Tell us what was missing (preview)
                  <textarea placeholder="Add comments…" />
                </label>
              )}
            </article>
          ))}
      </section>
    </div>
  );
}
